import { type PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import type { Nullable } from "@/types";

export type PortalProps = PropsWithChildren<{ portalId: string; renderPortal?: boolean }>;
export function Portal({ children, portalId, renderPortal = true }: PortalProps) {
    const [portalRoot, setPortalRoot] = useState<Nullable<HTMLDivElement>>(null);

    useEffect(() => {
        let container = document.getElementById(portalId) as Nullable<HTMLDivElement>;

        // Create container if showing devtools and it doesn't exist
        if (!container && renderPortal) {
            container = document.createElement("div");
            container.id = portalId;
            document.body.appendChild(container);
        }

        if (container && !renderPortal) {
            document.body.removeChild(container);
        }

        // eslint-disable-next-line react-hooks/set-state-in-effect
        setPortalRoot(renderPortal ? container : null);
    }, [portalId, renderPortal]);

    if (!portalRoot) return null;

    return createPortal(children, portalRoot);
}
